import React from 'react';
import CodeEventPage from '../components/CodeEventPage';

const CodeEventContainer = ({isLoading=false, itemId=''}) => {
  return <CodeEventPage itemId={itemId}  isLoading={isLoading} />;
};

export default CodeEventContainer;
